import { NudosHoverText, NudosSelectButton, NudosTextInput } from 'components/NudosComponents';
import { formatPills } from 'utils/pillsFormat';
import { IProductDelivery, IShipmentData } from 'types/orders';
import OrderSerialsList from '../OrderSerialsList/OrderSerialsList';
import './ProductSelectorList.scss';

interface ProductSelectorListProps {
  items: IShipmentData[];
  unselectedItems?: IShipmentData[];
  onToggleItem: (shipmentId: number) => void;
  isChecked?: boolean;
  showSerials?: boolean;
  editProductSerial?: (productId: number, newSerial: string) => void;
  getErrorText?: (itemData: IProductDelivery) => string | undefined;
  toggleProductSelection?: (productId: number) => void;
  selectedProductIds?: number[];
  hasStockReservation?: (product: IProductDelivery) => boolean;
  getStockReservationSerial?: (product: IProductDelivery) => string;
  isStockOrder?: boolean;
  requireSerials?: boolean;
}

/**
 * Componente reutilizable para mostrar listas de productos en el selector
 */
const ProductSelectorList: React.FC<ProductSelectorListProps> = ({
  items,
  unselectedItems = [],
  onToggleItem,
  isChecked,
  showSerials,
  editProductSerial,
  getErrorText,
  toggleProductSelection,
  selectedProductIds,
  hasStockReservation,
  getStockReservationSerial,
  isStockOrder,
  requireSerials
}) => {
  const totalItems = items?.length + unselectedItems?.length;
  const charactersLimit = 35;

  return (
    <div className="productSelectorList">
      {items?.map((item, index) => {
        const product = item?.products?.[0];
        const pills = product?.pills;
        const pillsList = pills
          ? formatPills({ pillsList: pills, excludeItems: ['Cargo', 'Gama', 'Perfil'] })
          : undefined;
        const selectedProductsInShipment =
          item?.products?.filter(product => selectedProductIds?.includes(product.id))?.length || 0;
        const totalProductsInShipment = item?.products?.length || 0;

        return (
          <div key={`shipment-${item.shipmentId}-index-${index}`} className="listProductsContainer">
            <div className={`listProducts ${index !== 0 ? 'topSpace' : ''}`}>
              <NudosSelectButton
                handleClickButton={() => onToggleItem(item?.shipmentId)}
                colorPalette="black"
                isButtonActive={!!isChecked}
                iconName="xmark"
              />

              <div className="productInformationContainer">
                <div className="productInformationContainerTop">
                  <span className="quantityOfProducts">{`Producto ${index + 1} de ${totalItems}`}</span>
                  <div className="selectedProductsCounter">
                    Has seleccionado {selectedProductsInShipment}/{totalProductsInShipment} unidades
                  </div>
                </div>

                <div className="specsListContainer">
                  <NudosHoverText
                    customClassName="specsFirstItem"
                    text={product?.name}
                    charactersLimit={charactersLimit}
                    onlyIfTruncated
                    maxHoverWidth="200px"
                  />
                  -
                  {pillsList?.pills?.map(pillItem => (
                    <span className="specsItem" key={`spectItem-${pillItem?.value}`}>
                      {`${pillItem?.value}`}
                    </span>
                  ))}
                  <span className="specsLastItem">{`Unidades: ${item?.products?.length}`}</span>
                </div>
              </div>
            </div>

            {!!showSerials && (
              <OrderSerialsList
                products={item?.products}
                editProductSerial={editProductSerial}
                getErrorText={getErrorText}
                toggleProductSelection={toggleProductSelection}
                selectedProductIds={selectedProductIds}
                hasStockReservation={hasStockReservation}
                getStockReservationSerial={getStockReservationSerial}
                isStockOrder={isStockOrder}
                requireSerials={requireSerials}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ProductSelectorList;
